import { Moment } from 'moment';
import { ChangeDetectionStrategy } from '@angular/core';
import * as moment from 'moment'
import { EProvider } from '../enum/provider.enum';
import { EVoucherType } from '../enum/voucher-type.enum';



export class Order
{
    moment = require("moment");

    providerId : number;
    voucherType: number;
    numberOfPayments : number;
    orderDate : Moment;
    numberOfEmployeeTicketsOrdered :number;
    numberOfNonEmployeeTicketsOrdered : number;
    numberOfChildTicketsOrdered:number

    constructor()
    {
        
        this.numberOfPayments = 0;
        this.orderDate = moment();
        this.numberOfEmployeeTicketsOrdered  = 0;
        this.numberOfNonEmployeeTicketsOrdered  = 0;
        this.numberOfChildTicketsOrdered = 0;
        this.providerId = 0;
        this.voucherType = 0; 
    }
        
}